import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import type { FC } from "react";

interface FewerRecipientsDialogProps {
  open: boolean;
  channelName: string | null;
  onConfirm: () => void;
  onCancel: () => void;
  isSameChannelType: boolean;
  willResetContent: boolean;
}

export const FewerRecipientsDialog: FC<FewerRecipientsDialogProps> = ({
  open,
  channelName,
  onConfirm,
  onCancel,
  isSameChannelType,
  willResetContent,
}) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Some recipients don’t have {channelName}</DialogTitle>
      <DialogContent>
        <Stack direction="column" spacing={2}>
          <Typography variant="body2">
            Some people in the original Communication’s segment don’t have this channel enabled.
          </Typography>
          <Typography variant="body2">
            If they meet the requirements for a Follow-Up, they won’t receive it if you use this
            channel - it’s best to stay with the original channel.
          </Typography>
          {!isSameChannelType && willResetContent && (
            <Alert severity="warning">
              <Typography variant="body2">
                Changing channel to {channelName} will clear all content from your Follow-Up, as
                newsletter formatting is not supported for this channel. This action cannot be
                undone.
              </Typography>
            </Alert>
          )}
          {!isSameChannelType && !willResetContent && (
            <Typography variant="body2">
              Additionally, changing the channel to {channelName} will convert your message content
              and remove unsupported formatting, including column layouts, button styling, and some
              text formatting. This conversion cannot be undone.
            </Typography>
          )}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "flex-end", px: 3, pb: 2 }}>
        <Button onClick={onConfirm} color="primary" data-analytics-id="follow-up-channel-switch">
          Switch channel{willResetContent && " and lose content"}
        </Button>
        <Button
          onClick={onCancel}
          color="primary"
          data-analytics-id="follow-up-channel-keep-original"
        >
          Keep original channel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
